import React from 'react';
import { useSearchParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Select, Option } from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import {
	orderFilerType,
	orderFilerTypeAlias,
	SlCodeBitsContext,
} from '../../global-constants';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { SlDataService } from '../../services/sl-data.service';
import { NewCode } from '../NewCode/NewCode';

import s from './CodeBitsFilter.scss';

export function CodeBitsFilter() {
	useStyles(s);
	const [searchParams, setSearchParams] = useSearchParams();

	const { supportedLanguages$: supportedLanguages } = useContainerData(
		SlCodeBitsContext,
		SlDataService,
		['supportedLanguages$'],
	);

	const orderChangeHandler = (selectedOrderFilter: string) => {
		const { actions$ } = Container.take(SlCodeBitsContext, SlActions);
		actions$.next({
			type: ActionType.OrderFilterChange,
			requestType: RequestType.Parallel,
			data: {
				selectedOrderFilter,
				selectedLanguageFilter: searchParams.get('language'),
			},
		});

		searchParams.set('ordering', orderFilerTypeAlias[selectedOrderFilter]);
		searchParams.set('page', '1');
		setSearchParams(searchParams);
	};

	const languageChangeHandler = (selectedLanguageFilter: string) => {
		const { actions$ } = Container.take(SlCodeBitsContext, SlActions);
		actions$.next({
			type: ActionType.LanguageFilterChange,
			requestType: RequestType.Parallel,
			data: {
				selectedOrderFilter: searchParams.get('ordering'),
				selectedLanguageFilter,
			},
		});

		if (selectedLanguageFilter === 'all') {
			searchParams.delete('language');
		} else {
			searchParams.set('language', selectedLanguageFilter);
		}

		searchParams.set('page', '1');
		setSearchParams(searchParams);
	};

	const currentFilterValue = Object.keys(orderFilerTypeAlias).find(
		(key) => orderFilerTypeAlias[key] === searchParams.get('ordering'),
	) || Object.keys(orderFilerType)[0];

	const currentLanguageValue = searchParams.get('language') || 'all';

	const filteredLanguages = supportedLanguages?.filter(
		({ key }) => key !== 'jquery' && key !== 'js' && key !== 'html' && key !== 'css',
	);

	return (
		<div className="sl-code-bits-filter">
			<div className="sl-code-bits-filter__filters">
				<Select
					name="code-bits-filter"
					value={currentFilterValue}
					className="sl-code-bits-filter__sort"
					onValueChange={orderChangeHandler}
					size="m"
				>
					{Object.keys(orderFilerType).map((typeKey) => (
						<Option value={typeKey} key={typeKey}>
							{i18n.t(orderFilerType[typeKey])}
						</Option>
					))}
				</Select>
				<Select
					name="code-bits-filter-mobile"
					value={currentFilterValue}
					className="sl-code-bits-filter__sort__small"
					onValueChange={orderChangeHandler}
					size="s"
				>
					{Object.keys(orderFilerType).map((typeKey) => (
						<Option value={typeKey} key={typeKey}>
							{i18n.t(orderFilerType[typeKey])}
						</Option>
					))}
				</Select>
				<Select
					name="code-bits-filter"
					value={currentLanguageValue}
					className="sl-code-bits-filter__sort"
					onValueChange={languageChangeHandler}
					size="m"
				>
					{filteredLanguages?.map((language) => (
						<Option value={language.key} key={language.key}>
							{language.displayName}
						</Option>
					))}
				</Select>
				<Select
					name="code-bits-filter-mobile"
					value={currentLanguageValue}
					className="sl-code-bits-filter__sort__small"
					onValueChange={languageChangeHandler}
					size="s"
				>
					{filteredLanguages?.map((language) => (
						<Option value={language.key} key={language.key}>
							{language.displayName}
						</Option>
					))}
				</Select>
			</div>
			<div className="sl-code-bits-filter__new-code">
				<NewCode />
			</div>
		</div>
	);
}
